import { createSelector, createFeatureSelector } from '@ngrx/store';

export const getMCAutopayInvoicingContext = createFeatureSelector('mcAutopayInvoicingContext');
export const getMCAutopayInvoicesByDate = createSelector(getMCAutopayInvoicingContext, (state: any) => state?.Invoices);
export const getMCAutopayInvoicesLoadedState = createSelector(getMCAutopayInvoicingContext, (state: any) => state?.invoicesLoaded);
export const getMCAutopayNumberedInvoiceState = createSelector(getMCAutopayInvoicingContext, (state: any) => state?.NumberedInvoiceFromSearch);
